export default __webpack_public_path__ + "static/media/iconCloseModal.c63c9404.svg";